import './geozone-tooltip.sass';
export function geozoneTooltip(layer) {
    return ('<div class="ui-map-draw-geozone-tooltip-window">' +
        '<h1 class="ui-map-draw-geozone-tooltip-name"> ' +
        // @ts-ignore
        (layer.feature.properties.name ?? '') +
        '</h1>' +
        // @ts-ignore
        (layer.feature.properties.description !== ''
            ? '<h2 class="ui-map-draw-geozone-tooltip"> ' +
                // @ts-ignore
                layer.feature.properties.description +
                '</h2>'
            : '') +
        '</div>');
}
